import content from './components/Content/Content'
export const routes = [
    {path: '/', component: content,name:'list'},

]